import { Grid, MenuItem, Select, Switch, TextField, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { BsNature } from "../../../models/BsNature";
import { VendorTitle } from "../../../models/VendorTitle";
import { PaymentPurpose } from "../../../models/PaymentPurpose";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../../reducers";
import { useSelector } from "react-redux";
import AllActions from "../../../actions";
import { useEffect } from "react";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailBasicMeta } from "../../../models/VendorDetail/VendorDetailBasicMeta";
import {
  FieldsLengthConstants,
  FileUploadTypes,
  NatureOfBusiness,
  RequestStatus,
  VendorCountry,
} from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";

export default function BascInfo(props: any) {
  const classes = useStyles();
  const {
    getErrorState,
    handleChange,
    prepareForRequest,
    compeleteRequest,
    isEditableMode,
    isDisplayRegistrationNumber,
    bsnature,
    vendotitle,
    handleOnBlur,
    getCompareField
  } = props;

  // const [bsnature, setBsnature] = useState(Array<BsNature>());
  //const [vendotitle, setVendotitle] = useState(Array<VendorTitle>());
  const [paymentpurpose, setPaymentpurpose] = useState(Array<PaymentPurpose>());
  //const [incotermsList, setIncotermsList] = useState(Array<PaymentPurpose>());
  // const [schemaGroupList, setSchemaGroupList] = useState(Array<PaymentPurpose>());

  const [isPvtNture, setIsPvtNture] = useState(false);
  const [isMasNature, setIsMasNature] = useState(false);
  const [isOtherNature, setIsOtherNature] = useState(false);
  const [isPublicnature, setPublicNature] = useState(false);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.formOneWrapper}
      >        
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_basic_bsnature_lbl}
              <label hidden={getCompareField("NatureOfBusinessId")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.NatureOfbusiness || ""}
              onChange={handleChange("NatureOfbusiness")}
              error={getErrorState("NatureOfbusiness")}
            >
              {bsnature.map((obj: BsNature, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
            <span className={classes.helpLbl}>{translation.vendor_detail_basic_bsnature_help}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_basic_vntitle_lbl}
              <label hidden={getCompareField("TitleCode")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Select
              variant="outlined"
              value={vendorDetail.Title || ""}
              onChange={handleChange("Title")}
              error={getErrorState("Title")}
            >
              {vendotitle.map((obj: VendorTitle, index: number) => (
                <MenuItem key={obj.code} value={obj.code}>
                  {obj.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_basic_name_lbl}
              <label hidden={getCompareField("Form2VendorName")} className={classes.editedLabel}>EDITED</label>
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
           <Tooltip title={translation.vendor_form_special_character_tooltip} placement="bottom-start">
            <TextField
              variant="outlined"
              value={vendorDetail.VendorName || ""}
              onChange={handleChange("VendorName")}
              error={getErrorState("VendorName")}
              inputProps={{ maxLength: FieldsLengthConstants.VendorName }}
              onBlur={handleOnBlur("VendorName")}
            />
            </Tooltip>
            <span className={classes.helpLbl}>{
              (vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery
              || vendorDetail.NatureOfbusiness === NatureOfBusiness.Partnership) 
              ? translation.vendor_detail_basic_name_sole_help
              : translation.vendor_detail_basic_name_other_help}</span>
          </Grid>
        </Grid>
        {isDisplayRegistrationNumber() && (
          <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {vendorDetail.AddressCoutry == VendorCountry.USA ? translation.vendor_detail_basic_bsregnumber_us_lbl : translation.vendor_detail_basic_bsregnumber_lbl}
                <label hidden={getCompareField("BusinessRegistrationNumber")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={
                isDisplayRegistrationNumber()
                  ? classes.inputWrapper_Req
                  : classes.formOneinputWrapper
              }
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Tooltip title={translation.vendor_form_special_character_tooltip} placement="bottom-start">
                <TextField
                  variant="outlined"
                  value={vendorDetail.BusRegNumber || ""}
                  onChange={handleChange("BusRegNumber")}
                  error={getErrorState("BusRegNumber")}
                  inputProps={{ maxLength: FieldsLengthConstants.BusRegNumber }}
                />                
              </Tooltip>
              <span className={classes.helpLbl}>{translation.vendor_detail_basic_bsregnumber_help}</span>
            </Grid>
          </Grid>
        )}

        {(vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery ||
          vendorDetail.NatureOfbusiness === NatureOfBusiness.MASEmployee) && (
          <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {vendorDetail.NatureOfbusiness ===
                NatureOfBusiness.SolePropritery
                  ? translation.vendor_detail_basic_nic_lbl
                  : translation.vendor_detail_basic_employeenic_lbl}
              <label hidden={getCompareField("VendorNic")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.inputWrapper_Req}
              //className={vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery ? classes.inputWrapper_Req:classes.formOneinputWrapper}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <TextField
                variant="outlined"
                value={vendorDetail.vendorNic || ""}
                onChange={handleChange("vendorNic")}
                error={getErrorState("vendorNic")}
                inputProps={{ maxLength: FieldsLengthConstants.VendorNIC }}
              />
            </Grid>
          </Grid>
        )}

        {vendorDetail.NatureOfbusiness === NatureOfBusiness.MASEmployee && (
          <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.formTwoLbl}>
                {translation.vendor_detail_basic_epf_lbl}
                <label hidden={getCompareField("VendorEpfno")} className={classes.editedLabel}>EDITED</label>
              </span>
            </Grid>
            <Grid
              className={classes.inputWrapper_Req}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <TextField
                variant="outlined"
                value={vendorDetail.EmployeeEPF || ""}
                onChange={handleChange("EmployeeEPF")}
                error={getErrorState("EmployeeEPF")}
                inputProps={{ maxLength: FieldsLengthConstants.EmployeeEPF }}

              />
            </Grid>
          </Grid>
        )}

        {(isDisplayRegistrationNumber() ||
            vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery) && (
            <Grid item xs={12} sm={12} md={6} lg={4} >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                {vendorDetail.AddressCoutry == VendorCountry.USA ? translation.vendor_detail_basic_bsregnumberattc_us_lbl : translation.vendor_detail_basic_bsregnumberattc_lbl}
                  <label hidden={getCompareField("RequestNo")} className={classes.editedLabel}>EDITED</label>
                </span>
              </Grid>
              <Grid
                className={classes.formOneinputWrapper}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <div className={classes.fileWrapper}>
                  <FileUpload
                    editable={vendorDetail.requestStatusId === RequestStatus.Initial}
                    requestNumber={vendorDetail.RequestNumber}
                    userfile={vendorDetail.BrFile || { fileId: 0, fileName: "", filePath: "" }}
                    attachmentType={
                      FileUploadTypes.CompanyLetterHeadConfirmingBR
                    }
                  ></FileUpload>
                </div>
              </Grid>
            </Grid>
          )}

        {(vendorDetail.NatureOfbusiness === NatureOfBusiness.MASEmployee ||
            vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery) && (
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.formTwoLbl}>
                  {translation.vendor_detail_basic_nicattattc_lbl}
                </span>
              </Grid>
              <Grid
                className={classes.formOneinputWrapper}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <div className={classes.fileWrapper}>
                  <FileUpload
                    editable={vendorDetail.requestStatusId === RequestStatus.Initial}
                    requestNumber={vendorDetail.RequestNumber}
                    userfile={vendorDetail.NicFile}
                    attachmentType={FileUploadTypes.NICCopy}
                  ></FileUpload>
                </div>
              </Grid>
            </Grid>
          )}
      </Grid>
    </div>
  );
}
